import { HotelsParams } from '../../../types/Hotels';

// Define global query keys for react-query to avoid keys collision
const queryKeys = {
  startPrices: (propertyIds?: (string | undefined)[] | string, date?: string, locale?: string) => {
    return ['startPrices', propertyIds, date, locale];
  },
  accountsCoupons: (page?: number) => ['accountsCoupons', page],
  accountsCouponsInfinite: () => ['accountsCouponsInfinite'],
  accountBookings: ({
    hasExpired,
    page,
    items,
    sort,
    locale,
    affiliateId,
  }: {
    hasExpired?: boolean;
    page?: string;
    items?: number;
    sort?: string;
    locale?: string;
    affiliateId?: string;
  }) => ['accountBookings', hasExpired, page, items, sort, locale, affiliateId],
  booking: ({
    bookingId,
    pinCode,
    authToken,
    locale,
  }: {
    bookingId: string;
    pinCode?: string;
    authToken?: string;
    locale?: string;
  }) => ['booking', bookingId, pinCode, authToken, locale],
  generateReceipt: ({
    bookingId,
    recipientName,
    locale,
  }: {
    bookingId: string;
    recipientName?: string;
    locale?: string;
  }) => ['generateReceipt', bookingId, recipientName, locale],
  getReceipt: ({
    bookingId,
    recipientName,
    receiptId,
    idToken,
    accountId,
    authToken,
    locale,
  }: {
    bookingId: string;
    recipientName?: string;
    receiptId?: string;
    idToken?: string;
    accountId?: string;
    authToken?: string;
    locale?: string;
  }) => ['getReceipt', bookingId, recipientName, receiptId, idToken, accountId, authToken, locale],
  otp: ({ bookingId }: { bookingId: string }) => ['otp', bookingId],
  partnershipSettings: () => ['partnershipSettings'],
  hotel: ({
    hotelId,
    checkInDate,
    checkOutDate,
    guestCountString,
    roomCount,
    locale,
  }: {
    hotelId: string;
    checkInDate: string;
    checkOutDate: string;
    guestCountString: string;
    roomCount: number;
    locale: string;
  }) => {
    return ['hotel', hotelId, checkInDate, checkOutDate, guestCountString, roomCount, locale];
  },
  hotels: ({
    q,
    locale,
    type,
    checkInDate,
    checkOutDate,
    guestPerRoom,
    roomCount,
    items,
    tags,
    prefectureAreas,
    minPrice,
    maxPrice,
    filterMembersPrice,
    latlng,
  }: Omit<HotelsParams, 'page'>) => [
    'hotels',
    q,
    locale,
    type,
    checkInDate,
    checkOutDate,
    guestPerRoom,
    roomCount,
    items,
    tags,
    prefectureAreas,
    minPrice,
    maxPrice,
    filterMembersPrice,
    latlng,
  ],
  searchAutocomplete: (term: string) => ['searchAutocomplete', term],
};

export default queryKeys;
